import { useAuthContext } from 'contexts';
import FHIRFetcher from 'data/FHIRFetcher';
import type { Bundle } from 'fhir/r4';
import useSWR from 'swr';
import type { Key } from 'swr';

type UseActivityTabProps = {
  taskId?: string | undefined;
};

export const useActivityTab = ({ taskId }: UseActivityTabProps) => {
  const { token } = useAuthContext();

  const taskOptions = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  };

  const { data: taskActivities, isValidating } = useSWR<Bundle, string>(
    // Conditional fetch: an absent `taskId` yields `undefined`, which swr 0.5.7 skips
    // on, though its `Key` type does not admit it.
    (taskId && [`/Task/` + taskId + '/_history', token]) as Key,
    // `FHIRFetcher` resolves `Bundle | undefined` for an empty endpoint, while swr
    // 0.5.7's fetcher parameter declares no `undefined`.
    FHIRFetcher as () => Promise<Bundle>,
    taskOptions
  );

  return { taskActivities, isLoading: isValidating };
};
